import { useEffect, useState } from 'react';
import { getAiProviders } from '../modules/aiConfig';

const FALLBACK = [
  {
    id: 'gemini',
    label: 'Gemini',
    enabled: true,
    models: [{ id: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash', recommended: true }],
  },
];

let _cache = null;

export function useAiProviders() {
  const [providers, setProviders] = useState(_cache ?? []);
  const [loading, setLoading] = useState(!_cache);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (_cache) return;
    let cancelled = false;

    getAiProviders()
      .then((data) => {
        if (cancelled) return;
        _cache = data.providers ?? FALLBACK;
        setProviders(_cache);
      })
      .catch(() => {
        if (cancelled) return;
        setError('Could not load providers.');
        setProviders(FALLBACK);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, []);

  return { providers, loading, error };
}